import { SortOrder, SortValues } from "@/shared/services/ReadingService";

export enum ResponseMode {
  Standard,
  ReadingResponse,
}

export const DefaultFilters = {
  sort: SortValues.CREATED_AT,
  order: SortOrder.DESC,
  offset: 0,
  limit: 25,
};

export const DEFAULT_READING_RESPONSE_BY_USER_STATUS = {
  CANCELED:
    "I'd love to answer this for you! I see that your account is canceled. Once you reactivate on the platform, please let me know and I'll be happy to read for you!",
  SKIPPED:
    "I'd love to answer this for you! I see that your account is skipped. Once you reactivate on the platform, please let me know and I'll be happy to read for you!",
  PAYMENT_FAILED:
    "I'd love to answer this for you! I see that your account is not current. Once your account is current, please let me know and I'll be happy to read for you!",
};

export const genderMap = {
  MAN: "Male",
  WOM: "Female",
  NON: "Non-binary",
  NUL: "Prefer not to say",
};

export const zodiacMap = {
  ARI: "Aries",
  TAE: "Taurus",
  GEM: "Gemini",
  CAN: "Cancer",
  LEO: "Leo",
  VIR: "Virgo",
  LIB: "Libra",
  SCO: "Scorpio",
  SAG: "Sagittarius",
  CAP: "Capricorn",
  AQU: "Aquarius",
  PIS: "Pisces",
};

export const experienceLevelMap = {
  0: "None",
  1: "Low",
  2: "Medium",
  3: "High",
};
